export default {
  stylePrefix: 'mdl-',

  title: '',

  content: '',

  backdrop: true
};



// WEBPACK FOOTER //
// webpack://grapesjs/src/modal_dialog/config/config.js